/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

/* tslint:disable */
/* eslint-disable */
// !!! DO NOT EDIT !!! Generated by graphql-codegen.

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
}

export const AccountAuthValueType = {
  Domain: "DOMAIN",
  Email: "EMAIL",
} as const

export type AccountAuthValueType =
  (typeof AccountAuthValueType)[keyof typeof AccountAuthValueType]
export type AthenaFilterInput = {
  filter_key: Scalars["String"]["input"]
  filter_operator: Scalars["String"]["input"]
  filter_table: Scalars["String"]["input"]
  filter_values: Array<Scalars["String"]["input"]>
}

export type BrandFilterInput = {
  exclude_seisen?: InputMaybe<Scalars["Boolean"]["input"]>
  intage_generic_category_lv3name?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >
  jicfs_lv4name?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  maker_name_orig?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  subcategory_name?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

export type Contact = {
  __typename?: "Contact"
  contact_detail?: Maybe<Scalars["String"]["output"]>
  contact_id: Scalars["Int"]["output"]
  contact_type?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["String"]["output"]>
  last_comment_date?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<ContactStatus>
  target_service?: Maybe<Scalars["String"]["output"]>
  unread_cnt?: Maybe<Scalars["Int"]["output"]>
}

export type ContactComment = {
  __typename?: "ContactComment"
  admin_id: Scalars["Int"]["output"]
  comment: Scalars["String"]["output"]
  contact_comment_id: Scalars["Int"]["output"]
  contact_id: Scalars["Int"]["output"]
  created_at?: Maybe<Scalars["String"]["output"]>
  is_read?: Maybe<Scalars["Int"]["output"]>
}

export const ContactStatus = {
  Done: "DONE",
  New: "NEW",
  Received: "RECEIVED",
} as const

export type ContactStatus = (typeof ContactStatus)[keyof typeof ContactStatus]
export type ContactType = {
  __typename?: "ContactType"
  contact_type: Scalars["String"]["output"]
  contact_type_id: Scalars["ID"]["output"]
}

export type DeliveryInfoDataInput = {
  deliveryDate: Scalars["String"]["input"]
  infoIds: Array<InputMaybe<Scalars["String"]["input"]>>
}

export type DeliveryInfoDataOutput = {
  __typename?: "DeliveryInfoDataOutput"
  deliveryDate: Scalars["String"]["output"]
  infoIds: Array<Maybe<Scalars["String"]["output"]>>
  userId: Scalars["String"]["output"]
}

export type Dist = {
  __typename?: "Dist"
  cnt?: Maybe<Scalars["Int"]["output"]>
  score?: Maybe<Scalars["Float"]["output"]>
}

export type FilteredItem = {
  __typename?: "FilteredItem"
  brand_name?: Maybe<Scalars["String"]["output"]>
  comment_cnt?: Maybe<Scalars["Int"]["output"]>
  identifier: Scalars["ID"]["output"]
  intage_generic_category_lv3name?: Maybe<Scalars["String"]["output"]>
  jicfs_lv4name?: Maybe<Scalars["String"]["output"]>
  maker_name_orig?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  score_avg?: Maybe<Scalars["Float"]["output"]>
  score_cnt?: Maybe<Scalars["Int"]["output"]>
  subbrand_name?: Maybe<Scalars["String"]["output"]>
  subcategory_name?: Maybe<Scalars["String"]["output"]>
}

export type GetAccountData = {
  __typename?: "GetAccountData"
  companyName?: Maybe<Scalars["String"]["output"]>
  departmentName?: Maybe<Scalars["String"]["output"]>
  divisionName?: Maybe<Scalars["String"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  termsAcceptDate?: Maybe<Scalars["String"]["output"]>
  userName?: Maybe<Scalars["String"]["output"]>
}

export type GetContactCommentsInput = {
  contact_id: Scalars["Int"]["input"]
}

export type GetContactsInput = {
  pager?: InputMaybe<PagerInput>
}

export type GetContactsOutput = {
  __typename?: "GetContactsOutput"
  contacts: Array<Contact>
  totalCount?: Maybe<Scalars["Int"]["output"]>
}

export type GetUnreadSummaryOutput = {
  __typename?: "GetUnreadSummaryOutput"
  uncheckedContactCnt: Scalars["Int"]["output"]
  unreadInfoCnt: Scalars["Int"]["output"]
}

export type InfoData = {
  __typename?: "InfoData"
  content?: Maybe<Scalars["String"]["output"]>
  delivered?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["ID"]["output"]
  openDate?: Maybe<Scalars["String"]["output"]>
  readed?: Maybe<Scalars["Boolean"]["output"]>
  title?: Maybe<Scalars["String"]["output"]>
}

export type InfoDataInput = {
  pager?: InputMaybe<PagerInput>
}

export type InfoDataOutput = {
  __typename?: "InfoDataOutput"
  infoDataItems?: Maybe<Array<Maybe<InfoData>>>
  totalCount?: Maybe<Scalars["Int"]["output"]>
  unreadCnt?: Maybe<Scalars["Int"]["output"]>
}

export type IshopChain = {
  __typename?: "IshopChain"
  code: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
}

export type ItemFilterInput = {
  brand_name?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  categoryDefinition?: InputMaybe<Scalars["String"]["input"]>
  identifier?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  intage_generic_category_lv3name?: InputMaybe<
    Array<Scalars["String"]["input"]>
  >
  jicfs_lv4name?: InputMaybe<Array<Scalars["String"]["input"]>>
  maker_name_orig?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  pager?: InputMaybe<PagerInput>
  subcategory_name?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  term_from?: InputMaybe<Scalars["String"]["input"]>
  term_to?: InputMaybe<Scalars["String"]["input"]>
}

export type ItemFilterOutput = {
  __typename?: "ItemFilterOutput"
  cnt?: Maybe<Scalars["Int"]["output"]>
  filteredItems?: Maybe<Array<Maybe<FilteredItem>>>
  pager?: Maybe<Pager>
}

export type JicfsCategoryBrand = {
  __typename?: "JicfsCategoryBrand"
  brand_code: Scalars["String"]["output"]
  brand_name: Scalars["String"]["output"]
  lv1code: Scalars["String"]["output"]
  lv1name: Scalars["String"]["output"]
  lv2code: Scalars["String"]["output"]
  lv2name: Scalars["String"]["output"]
  lv3code: Scalars["String"]["output"]
  lv3name: Scalars["String"]["output"]
  lv4code: Scalars["String"]["output"]
  lv4name: Scalars["String"]["output"]
}

export type LoginDummyUserResult = {
  __typename?: "LoginDummyUserResult"
  message?: Maybe<Scalars["String"]["output"]>
  success: Scalars["Boolean"]["output"]
}

export type MakerFilterInput = {
  intage_generic_category_lv3name?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >
  jicfs_lv4name?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  subcategory_name?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

export type Mutation = {
  __typename?: "Mutation"
  addSignalGroupMember: Scalars["Boolean"]["output"]
  agreeSignalTermsOfService: Scalars["Boolean"]["output"]
  deleteSignalGroupMember: Scalars["Boolean"]["output"]
  deleteSignalSetting: Scalars["Boolean"]["output"]
  deleteSignalUserTeam: Scalars["Boolean"]["output"]
  loginDummyUser?: Maybe<LoginDummyUserResult>
  readContactComments: ReadContactCommentsOutput
  saveAccountData: SaveAccountDataOutput
  saveDeliveryInfoData?: Maybe<DeliveryInfoDataOutput>
  saveReadedInfoData?: Maybe<ReadedInfoDataOutput>
  saveSignalMonitoringRecipients: Scalars["Boolean"]["output"]
  saveSignalSetting: Scalars["ID"]["output"]
  saveSignalUserTeam: Scalars["ID"]["output"]
  saveSignalUserTeamMembers: Scalars["Boolean"]["output"]
  sendContact?: Maybe<Contact>
  sendContactComment?: Maybe<ContactComment>
  toggleSignalSettingActive: Scalars["Boolean"]["output"]
  updateAcceptDate: Scalars["Boolean"]["output"]
}

export type MutationAddSignalGroupMemberArgs = {
  data: SignalGroupMemberAddInput
}

export type MutationAgreeSignalTermsOfServiceArgs = {
  group_member_id: Scalars["ID"]["input"]
}

export type MutationDeleteSignalGroupMemberArgs = {
  data: SignalGroupMemberDeleteInput
}

export type MutationDeleteSignalSettingArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationDeleteSignalUserTeamArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationLoginDummyUserArgs = {
  companyCode: Scalars["String"]["input"]
}

export type MutationReadContactCommentsArgs = {
  data: ReadContactCommentsInput
}

export type MutationSaveAccountDataArgs = {
  accountData: SaveAccountDataInput
}

export type MutationSaveDeliveryInfoDataArgs = {
  data: DeliveryInfoDataInput
}

export type MutationSaveReadedInfoDataArgs = {
  data: ReadedInfoDataInput
}

export type MutationSaveSignalMonitoringRecipientsArgs = {
  data: SignalMonitoringRecipientsUpsertInput
}

export type MutationSaveSignalSettingArgs = {
  data: SignalSettingInput
}

export type MutationSaveSignalUserTeamArgs = {
  data: SignalUserTeamUpsertInput
}

export type MutationSaveSignalUserTeamMembersArgs = {
  data: SignalUserTeamMembersUpsertInput
}

export type MutationSendContactArgs = {
  data: SendContactInput
}

export type MutationSendContactCommentArgs = {
  data: SendContactCommentInput
}

export type MutationToggleSignalSettingActiveArgs = {
  id: Scalars["ID"]["input"]
}

export type Pager = {
  __typename?: "Pager"
  item_offset?: Maybe<Scalars["Int"]["output"]>
  per_page?: Maybe<Scalars["Int"]["output"]>
}

export type PagerInput = {
  item_offset?: InputMaybe<Scalars["Int"]["input"]>
  per_page?: InputMaybe<Scalars["Int"]["input"]>
}

export type Query = {
  __typename?: "Query"
  getAccountData: GetAccountData
  getAthenaIShopChains: Array<IshopChain>
  getAthenaSignalGroupCategoriesBrands: Array<JicfsCategoryBrand>
  getBrandOptions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  getCategoryOptions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  getContactComments: Array<Maybe<ContactComment>>
  getContactDetail: Contact
  getContactTypes: Array<ContactType>
  getContacts: GetContactsOutput
  getFilteredItems?: Maybe<ItemFilterOutput>
  getInfoData?: Maybe<InfoDataOutput>
  getMakerOptions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  getReviews?: Maybe<ReviewFilterOutput>
  getSignalAuthorization?: Maybe<SignalUser>
  getSignalBrandSalesAmount: SignalBrandSalesAmountOutput
  getSignalBrandSalesRate: SignalBrandRateOutput
  getSignalBrandShareRate: SignalBrandRateOutput
  getSignalGroupMembers: SignalGroupMembersOutput
  getSignalMonitoringRecipients: Array<SignalMonitoringRecipient>
  getSignalMonitoringSettings: SignalMonitoringSettingsOutput
  getSignalUserTeamMembers: Array<SignalUser>
  getSignalUserTeams: SignalUserTeamsOutput
  getSubcategoryOptions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  getTargetServices: Array<TargetService>
  getTerms: Terms
  getUnreadSummary?: Maybe<GetUnreadSummaryOutput>
  reviewsToExcel?: Maybe<SignedUrl>
  selfInterviewSeamlessLogin?: Maybe<Scalars["String"]["output"]>
}

export type QueryGetBrandOptionsArgs = {
  filter?: InputMaybe<BrandFilterInput>
}

export type QueryGetCategoryOptionsArgs = {
  categoryDefinition: Scalars["String"]["input"]
}

export type QueryGetContactCommentsArgs = {
  filter: GetContactCommentsInput
}

export type QueryGetContactDetailArgs = {
  contactId: Scalars["Int"]["input"]
}

export type QueryGetContactsArgs = {
  filter?: InputMaybe<GetContactsInput>
}

export type QueryGetFilteredItemsArgs = {
  filterInput: ItemFilterInput
}

export type QueryGetInfoDataArgs = {
  filter?: InputMaybe<InfoDataInput>
}

export type QueryGetMakerOptionsArgs = {
  filter?: InputMaybe<MakerFilterInput>
}

export type QueryGetReviewsArgs = {
  filter: ReviewFilterInput
}

export type QueryGetSignalBrandSalesAmountArgs = {
  amount_type: Scalars["String"]["input"]
  data: SignalBrandMonitoringConditionInput
}

export type QueryGetSignalBrandSalesRateArgs = {
  data: SignalBrandMonitoringConditionInput
}

export type QueryGetSignalBrandShareRateArgs = {
  data: SignalBrandMonitoringConditionInput
}

export type QueryGetSignalGroupMembersArgs = {
  pager?: InputMaybe<PagerInput>
}

export type QueryGetSignalMonitoringRecipientsArgs = {
  signal_setting_id: Scalars["ID"]["input"]
}

export type QueryGetSignalMonitoringSettingsArgs = {
  pager?: InputMaybe<PagerInput>
}

export type QueryGetSignalUserTeamMembersArgs = {
  signal_user_team_id: Scalars["ID"]["input"]
}

export type QueryGetSignalUserTeamsArgs = {
  pager?: InputMaybe<PagerInput>
}

export type QueryGetSubcategoryOptionsArgs = {
  filter?: InputMaybe<SubcategoryFilterInput>
}

export type QueryReviewsToExcelArgs = {
  data: ReviewFilterInput
}

export type ReadContactCommentsInput = {
  contact_comment_id: Scalars["Int"]["input"]
  contact_id: Scalars["Int"]["input"]
}

export type ReadContactCommentsOutput = {
  __typename?: "ReadContactCommentsOutput"
  contact_comment_id: Scalars["Int"]["output"]
  contact_id: Scalars["Int"]["output"]
}

export type ReadedInfoDataInput = {
  infoId: Scalars["String"]["input"]
  readDate: Scalars["String"]["input"]
}

export type ReadedInfoDataOutput = {
  __typename?: "ReadedInfoDataOutput"
  id: Scalars["ID"]["output"]
  infoId: Scalars["String"]["output"]
  readDate: Scalars["String"]["output"]
  userId: Scalars["String"]["output"]
}

export type Review = {
  __typename?: "Review"
  age_group?: Maybe<Scalars["String"]["output"]>
  comment?: Maybe<Scalars["String"]["output"]>
  comment_length?: Maybe<Scalars["Int"]["output"]>
  identifier: Scalars["ID"]["output"]
  intage_generic_category_lv3name?: Maybe<Scalars["String"]["output"]>
  jicfs_lv4name?: Maybe<Scalars["String"]["output"]>
  maker_name_orig?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  pref?: Maybe<Scalars["String"]["output"]>
  review_updated_at?: Maybe<Scalars["String"]["output"]>
  score?: Maybe<Scalars["Float"]["output"]>
  sex?: Maybe<Scalars["String"]["output"]>
}

export type ReviewFilterInput = {
  brand_name?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  categoryDefinition?: InputMaybe<Scalars["String"]["input"]>
  identifier?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  intage_generic_category_lv3name?: InputMaybe<
    Array<Scalars["String"]["input"]>
  >
  jicfs_lv4name?: InputMaybe<Array<Scalars["String"]["input"]>>
  maker_name_orig?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  pager?: InputMaybe<PagerInput>
  subcategory_name?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  term_from?: InputMaybe<Scalars["String"]["input"]>
  term_to?: InputMaybe<Scalars["String"]["input"]>
}

export type ReviewFilterOutput = {
  __typename?: "ReviewFilterOutput"
  cnt?: Maybe<Scalars["Int"]["output"]>
  cnt_review?: Maybe<Scalars["Int"]["output"]>
  dist?: Maybe<Array<Maybe<Dist>>>
  pager?: Maybe<Pager>
  reviews?: Maybe<Array<Maybe<Review>>>
  score_avg?: Maybe<Scalars["Float"]["output"]>
}

export type SaveAccountDataInput = {
  accountDataSession: Scalars["String"]["input"]
  companyName: Scalars["String"]["input"]
  departmentName: Scalars["String"]["input"]
  divisionName: Scalars["String"]["input"]
  userName: Scalars["String"]["input"]
}

export type SaveAccountDataOutput = {
  __typename?: "SaveAccountDataOutput"
  result: Scalars["Boolean"]["output"]
}

export type SendContactCommentInput = {
  comment: Scalars["String"]["input"]
  contact_id: Scalars["Int"]["input"]
}

export type SendContactInput = {
  contact_detail: Scalars["String"]["input"]
  contact_type_id: Scalars["Int"]["input"]
  target_service_id: Scalars["Int"]["input"]
}

export type SignalBrandMonitoringConditionInput = {
  areas?: InputMaybe<Array<Scalars["String"]["input"]>>
  categories: Array<Scalars["String"]["input"]>
  channels?: InputMaybe<Array<Scalars["String"]["input"]>>
  comperetive_brand_names: Array<Scalars["String"]["input"]>
  gender_ages?: InputMaybe<Array<Scalars["String"]["input"]>>
  shop_chains?: InputMaybe<Array<Scalars["String"]["input"]>>
  start_date: Scalars["String"]["input"]
  target_brand_name: Scalars["String"]["input"]
  target_days: Scalars["Int"]["input"]
}

export type SignalBrandRate = {
  __typename?: "SignalBrandRate"
  brand_name: Scalars["String"]["output"]
  brand_rate: Scalars["Float"]["output"]
  term: Scalars["String"]["output"]
}

export type SignalBrandRateOutput = {
  __typename?: "SignalBrandRateOutput"
  comperetive_brand_results: Array<SignalBrandRate>
  target_brand_result: Array<SignalBrandRate>
}

export type SignalBrandSalesAmount = {
  __typename?: "SignalBrandSalesAmount"
  brand_name: Scalars["String"]["output"]
  brand_sales_amount: Scalars["Int"]["output"]
  term: Scalars["String"]["output"]
}

export type SignalBrandSalesAmountOutput = {
  __typename?: "SignalBrandSalesAmountOutput"
  comperetive_brand_results: Array<SignalBrandSalesAmount>
  target_brand_result: Array<SignalBrandSalesAmount>
}

export type SignalGroupMemberAddInput = {
  email: Scalars["String"]["input"]
  member_type: Scalars["Int"]["input"]
  signal_group_id: Scalars["ID"]["input"]
}

export type SignalGroupMemberDeleteInput = {
  signal_group_id: Scalars["ID"]["input"]
  signal_group_member_id: Scalars["ID"]["input"]
}

export type SignalGroupMembersOutput = {
  __typename?: "SignalGroupMembersOutput"
  members: Array<SignalUser>
  totalCount: Scalars["Int"]["output"]
}

export type SignalMonitoringRecipient = {
  __typename?: "SignalMonitoringRecipient"
  created_at: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  recipient_model_id: Scalars["ID"]["output"]
  type: Scalars["Int"]["output"]
  updated_at: Scalars["String"]["output"]
}

export type SignalMonitoringRecipientInput = {
  recipient_model_id: Scalars["ID"]["input"]
  type: Scalars["Int"]["input"]
}

export type SignalMonitoringRecipientsUpsertInput = {
  recipients: Array<SignalMonitoringRecipientInput>
  signal_setting_id: Scalars["ID"]["input"]
}

export type SignalMonitoringSetting = {
  __typename?: "SignalMonitoringSetting"
  active: Scalars["Boolean"]["output"]
  areas?: Maybe<Array<Scalars["String"]["output"]>>
  categories: Array<Scalars["String"]["output"]>
  channels?: Maybe<Array<Scalars["String"]["output"]>>
  created_at: Scalars["String"]["output"]
  deleted_at?: Maybe<Scalars["String"]["output"]>
  gender_ages?: Maybe<Array<Scalars["String"]["output"]>>
  id: Scalars["ID"]["output"]
  max_threshold?: Maybe<Scalars["Float"]["output"]>
  min_threshold?: Maybe<Scalars["Float"]["output"]>
  name: Scalars["String"]["output"]
  notice_type: Scalars["Int"]["output"]
  shop_chains?: Maybe<Array<Scalars["String"]["output"]>>
  signal_type: Scalars["Int"]["output"]
  target_brand_name?: Maybe<Scalars["String"]["output"]>
  target_days: Scalars["Int"]["output"]
  threshold_level?: Maybe<Scalars["Int"]["output"]>
  updated_at: Scalars["String"]["output"]
}

export type SignalMonitoringSettingsOutput = {
  __typename?: "SignalMonitoringSettingsOutput"
  settings?: Maybe<Array<SignalMonitoringSetting>>
  totalCount?: Maybe<Scalars["Int"]["output"]>
}

export type SignalSettingInput = {
  active: Scalars["Boolean"]["input"]
  areas?: InputMaybe<Array<Scalars["String"]["input"]>>
  categories: Array<Scalars["String"]["input"]>
  channels?: InputMaybe<Array<Scalars["String"]["input"]>>
  gender_ages?: InputMaybe<Array<Scalars["String"]["input"]>>
  id?: InputMaybe<Scalars["ID"]["input"]>
  max_threshold?: InputMaybe<Scalars["Float"]["input"]>
  min_threshold?: InputMaybe<Scalars["Float"]["input"]>
  name: Scalars["String"]["input"]
  notice_type: Scalars["Int"]["input"]
  shop_chains?: InputMaybe<Array<Scalars["String"]["input"]>>
  signal_type: Scalars["Int"]["input"]
  target_brand_name?: InputMaybe<Scalars["String"]["input"]>
  target_days: Scalars["Int"]["input"]
  threshold_level?: InputMaybe<Scalars["Int"]["input"]>
}

export type SignalUser = {
  __typename?: "SignalUser"
  created_at: Scalars["String"]["output"]
  email: Scalars["String"]["output"]
  first_name: Scalars["String"]["output"]
  last_name: Scalars["String"]["output"]
  member_type: Scalars["Int"]["output"]
  service_agreement: Scalars["Boolean"]["output"]
  signal_group_id: Scalars["ID"]["output"]
  signal_group_member_id: Scalars["ID"]["output"]
  updated_at: Scalars["String"]["output"]
  user_id: Scalars["String"]["output"]
}

export type SignalUserTeam = {
  __typename?: "SignalUserTeam"
  created_at: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  name: Scalars["String"]["output"]
  signal_group_id: Scalars["ID"]["output"]
  updated_at: Scalars["String"]["output"]
}

export type SignalUserTeamMembersUpsertInput = {
  signal_group_member_ids: Array<Scalars["ID"]["input"]>
  signal_user_team_id: Scalars["ID"]["input"]
}

export type SignalUserTeamUpsertInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>
  name: Scalars["String"]["input"]
}

export type SignalUserTeamsOutput = {
  __typename?: "SignalUserTeamsOutput"
  teams: Array<SignalUserTeam>
  totalCount: Scalars["Int"]["output"]
}

export type SignedUrl = {
  __typename?: "SignedUrl"
  url: Scalars["String"]["output"]
}

export type SubcategoryFilterInput = {
  intage_generic_category_lv3name?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >
  jicfs_lv4name?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

export type TargetService = {
  __typename?: "TargetService"
  target_service: Scalars["String"]["output"]
  target_service_id: Scalars["ID"]["output"]
}

export type Terms = {
  __typename?: "Terms"
  button: Scalars["String"]["output"]
  buttonEn: Scalars["String"]["output"]
  content: Scalars["String"]["output"]
  contentEn: Scalars["String"]["output"]
  termsId: Scalars["ID"]["output"]
  updateDate: Scalars["String"]["output"]
}

export type GetContactTypesQueryVariables = Exact<{ [key: string]: never }>

export type GetContactTypesQuery = {
  __typename?: "Query"
  getContactTypes: Array<{
    __typename?: "ContactType"
    contact_type_id: string
    contact_type: string
  }>
}

export type GetTargetServicesQueryVariables = Exact<{ [key: string]: never }>

export type GetTargetServicesQuery = {
  __typename?: "Query"
  getTargetServices: Array<{
    __typename?: "TargetService"
    target_service_id: string
    target_service: string
  }>
}

export type GetContactDetailQueryVariables = Exact<{
  contactId: Scalars["Int"]["input"]
}>

export type GetContactDetailQuery = {
  __typename?: "Query"
  getContactDetail: {
    __typename?: "Contact"
    contact_id: number
    contact_detail?: string | null
    contact_type?: string | null
    target_service?: string | null
  }
}

export type GetContactCommentsQueryVariables = Exact<{
  filter: GetContactCommentsInput
}>

export type GetContactCommentsQuery = {
  __typename?: "Query"
  getContactComments: Array<{
    __typename?: "ContactComment"
    contact_comment_id: number
    contact_id: number
    comment: string
    admin_id: number
    created_at?: string | null
    is_read?: number | null
  } | null>
}

export type SendContactCommentMutationVariables = Exact<{
  data: SendContactCommentInput
}>

export type SendContactCommentMutation = {
  __typename?: "Mutation"
  sendContactComment?: {
    __typename?: "ContactComment"
    contact_comment_id: number
    contact_id: number
    comment: string
    admin_id: number
    created_at?: string | null
    is_read?: number | null
  } | null
}

export type ReadContactCommentsMutationVariables = Exact<{
  Data: ReadContactCommentsInput
}>

export type ReadContactCommentsMutation = {
  __typename?: "Mutation"
  readContactComments: {
    __typename?: "ReadContactCommentsOutput"
    contact_id: number
    contact_comment_id: number
  }
}

export type SendContactMutationVariables = Exact<{
  data: SendContactInput
}>

export type SendContactMutation = {
  __typename?: "Mutation"
  sendContact?: {
    __typename?: "Contact"
    contact_id: number
    contact_type?: string | null
    target_service?: string | null
    contact_detail?: string | null
    status?: ContactStatus | null
    created_at?: string | null
  } | null
}

export type SelfInterviewSeamlessLoginQueryVariables = Exact<{
  [key: string]: never
}>

export type SelfInterviewSeamlessLoginQuery = {
  __typename?: "Query"
  selfInterviewSeamlessLogin?: string | null
}

export type GetInformationsQueryVariables = Exact<{
  filter: InfoDataInput
}>

export type GetInformationsQuery = {
  __typename?: "Query"
  getInfoData?: {
    __typename?: "InfoDataOutput"
    totalCount?: number | null
    unreadCnt?: number | null
    infoDataItems?: Array<{
      __typename?: "InfoData"
      id: string
      title?: string | null
      content?: string | null
      openDate?: string | null
      readed?: boolean | null
      delivered?: boolean | null
    } | null> | null
  } | null
}

export type SaveReadedInfoDataMutationVariables = Exact<{
  Data: ReadedInfoDataInput
}>

export type SaveReadedInfoDataMutation = {
  __typename?: "Mutation"
  saveReadedInfoData?: {
    __typename?: "ReadedInfoDataOutput"
    id: string
    infoId: string
    userId: string
    readDate: string
  } | null
}

export type GetReviewsQueryVariables = Exact<{
  ReviewFilterInput: ReviewFilterInput
}>

export type GetReviewsQuery = {
  __typename?: "Query"
  getReviews?: {
    __typename?: "ReviewFilterOutput"
    cnt?: number | null
    cnt_review?: number | null
    score_avg?: number | null
    reviews?: Array<{
      __typename?: "Review"
      score?: number | null
      comment?: string | null
      comment_length?: number | null
      review_updated_at?: string | null
      identifier: string
      name?: string | null
      intage_generic_category_lv3name?: string | null
      jicfs_lv4name?: string | null
      maker_name_orig?: string | null
      sex?: string | null
      age_group?: string | null
      pref?: string | null
    } | null> | null
    dist?: Array<{
      __typename?: "Dist"
      score?: number | null
      cnt?: number | null
    } | null> | null
  } | null
}

export type ReviewsToExcelQueryVariables = Exact<{
  DataInput: ReviewFilterInput
}>

export type ReviewsToExcelQuery = {
  __typename?: "Query"
  reviewsToExcel?: { __typename?: "SignedUrl"; url: string } | null
}

export type GetBrandOptionsQueryVariables = Exact<{
  BrandFilterInput?: InputMaybe<BrandFilterInput>
}>

export type GetBrandOptionsQuery = {
  __typename?: "Query"
  getBrandOptions?: Array<string | null> | null
}

export type GetCategoryOptionsQueryVariables = Exact<{
  categoryDefinition: Scalars["String"]["input"]
}>

export type GetCategoryOptionsQuery = {
  __typename?: "Query"
  getCategoryOptions?: Array<string | null> | null
}

export type GetMakerOptionsQueryVariables = Exact<{
  MakerFilterInput?: InputMaybe<MakerFilterInput>
}>

export type GetMakerOptionsQuery = {
  __typename?: "Query"
  getMakerOptions?: Array<string | null> | null
}

export type GetSubCategoryOptionsQueryVariables = Exact<{
  SubcategoryFilterInput?: InputMaybe<SubcategoryFilterInput>
}>

export type GetSubCategoryOptionsQuery = {
  __typename?: "Query"
  getSubcategoryOptions?: Array<string | null> | null
}

export type GetItemsQueryVariables = Exact<{
  ItemFilterInput: ItemFilterInput
}>

export type GetItemsQuery = {
  __typename?: "Query"
  getFilteredItems?: {
    __typename?: "ItemFilterOutput"
    cnt?: number | null
    filteredItems?: Array<{
      __typename?: "FilteredItem"
      identifier: string
      name: string
      maker_name_orig?: string | null
      intage_generic_category_lv3name?: string | null
      jicfs_lv4name?: string | null
      subcategory_name?: string | null
      brand_name?: string | null
      subbrand_name?: string | null
      score_avg?: number | null
      score_cnt?: number | null
      comment_cnt?: number | null
    } | null> | null
  } | null
}

export type GetAccountCategoryQueryVariables = Exact<{
  categoryDefinition1: Scalars["String"]["input"]
  categoryDefinition2: Scalars["String"]["input"]
}>

export type GetAccountCategoryQuery = {
  __typename?: "Query"
  intageCategory?: Array<string | null> | null
  jicfsCategory?: Array<string | null> | null
}

export type GetUnreadSummaryQueryVariables = Exact<{ [key: string]: never }>

export type GetUnreadSummaryQuery = {
  __typename?: "Query"
  getUnreadSummary?: {
    __typename?: "GetUnreadSummaryOutput"
    unreadInfoCnt: number
    uncheckedContactCnt: number
  } | null
}

export type SaveAccountDataMutationVariables = Exact<{
  Data: SaveAccountDataInput
}>

export type SaveAccountDataMutation = {
  __typename?: "Mutation"
  saveAccountData: { __typename?: "SaveAccountDataOutput"; result: boolean }
}

export type GetAcceptDateQueryVariables = Exact<{ [key: string]: never }>

export type GetAcceptDateQuery = {
  __typename?: "Query"
  getAccountData: {
    __typename?: "GetAccountData"
    termsAcceptDate?: string | null
  }
  getTerms: {
    __typename?: "Terms"
    content: string
    contentEn: string
    button: string
    buttonEn: string
    updateDate: string
  }
}

export type GetInfoDataQueryVariables = Exact<{ [key: string]: never }>

export type GetInfoDataQuery = {
  __typename?: "Query"
  getInfoData?: {
    __typename?: "InfoDataOutput"
    infoDataItems?: Array<{
      __typename?: "InfoData"
      id: string
      title?: string | null
      content?: string | null
      openDate?: string | null
      readed?: boolean | null
      delivered?: boolean | null
    } | null> | null
  } | null
}

export type GetUnreadSummaryHeaderQueryVariables = Exact<{
  [key: string]: never
}>

export type GetUnreadSummaryHeaderQuery = {
  __typename?: "Query"
  getUnreadSummary?: {
    __typename?: "GetUnreadSummaryOutput"
    unreadInfoCnt: number
    uncheckedContactCnt: number
  } | null
}

export type SaveDeliveryInfoDataMutationVariables = Exact<{
  Data: DeliveryInfoDataInput
}>

export type SaveDeliveryInfoDataMutation = {
  __typename?: "Mutation"
  saveDeliveryInfoData?: {
    __typename?: "DeliveryInfoDataOutput"
    infoIds: Array<string | null>
    userId: string
    deliveryDate: string
  } | null
}

export type GetContactsQueryVariables = Exact<{ [key: string]: never }>

export type GetContactsQuery = {
  __typename?: "Query"
  getContacts: {
    __typename?: "GetContactsOutput"
    contacts: Array<{ __typename?: "Contact"; unread_cnt?: number | null }>
  }
}

export const GetContactTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getContactTypes" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getContactTypes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact_type_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact_type" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetContactTypesQuery,
  GetContactTypesQueryVariables
>
export const GetTargetServicesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getTargetServices" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTargetServices" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "target_service_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "target_service" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTargetServicesQuery,
  GetTargetServicesQueryVariables
>
export const GetContactDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getContactDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getContactDetail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "contactId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contactId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact_detail" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact_type" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "target_service" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetContactDetailQuery,
  GetContactDetailQueryVariables
>
export const GetContactCommentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getContactComments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetContactCommentsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getContactComments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact_comment_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
                { kind: "Field", name: { kind: "Name", value: "admin_id" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "is_read" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetContactCommentsQuery,
  GetContactCommentsQueryVariables
>
export const SendContactCommentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendContactComment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SendContactCommentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendContactComment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact_comment_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
                { kind: "Field", name: { kind: "Name", value: "admin_id" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "is_read" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendContactCommentMutation,
  SendContactCommentMutationVariables
>
export const ReadContactCommentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "readContactComments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "Data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ReadContactCommentsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "readContactComments" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "Data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact_comment_id" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReadContactCommentsMutation,
  ReadContactCommentsMutationVariables
>
export const SendContactDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "sendContact" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SendContactInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendContact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact_type" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "target_service" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact_detail" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendContactMutation, SendContactMutationVariables>
export const SelfInterviewSeamlessLoginDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "selfInterviewSeamlessLogin" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "selfInterviewSeamlessLogin" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SelfInterviewSeamlessLoginQuery,
  SelfInterviewSeamlessLoginQueryVariables
>
export const GetInformationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getInformations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InfoDataInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getInfoData" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infoDataItems" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "openDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "readed" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "delivered" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                { kind: "Field", name: { kind: "Name", value: "unreadCnt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInformationsQuery,
  GetInformationsQueryVariables
>
export const SaveReadedInfoDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveReadedInfoData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "Data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ReadedInfoDataInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "saveReadedInfoData" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "Data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "infoId" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "readDate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveReadedInfoDataMutation,
  SaveReadedInfoDataMutationVariables
>
export const GetReviewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getReviews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ReviewFilterInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ReviewFilterInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getReviews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ReviewFilterInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reviews" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "score" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "comment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "comment_length" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "review_updated_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "intage_generic_category_lv3name",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "jicfs_lv4name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maker_name_orig" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sex" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "age_group" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "pref" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cnt" } },
                { kind: "Field", name: { kind: "Name", value: "cnt_review" } },
                { kind: "Field", name: { kind: "Name", value: "score_avg" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dist" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "score" } },
                      { kind: "Field", name: { kind: "Name", value: "cnt" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetReviewsQuery, GetReviewsQueryVariables>
export const ReviewsToExcelDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "reviewsToExcel" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "DataInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ReviewFilterInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reviewsToExcel" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "DataInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReviewsToExcelQuery, ReviewsToExcelQueryVariables>
export const GetBrandOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getBrandOptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "BrandFilterInput" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "BrandFilterInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getBrandOptions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "BrandFilterInput" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBrandOptionsQuery,
  GetBrandOptionsQueryVariables
>
export const GetCategoryOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCategoryOptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "categoryDefinition" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getCategoryOptions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "categoryDefinition" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "categoryDefinition" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCategoryOptionsQuery,
  GetCategoryOptionsQueryVariables
>
export const GetMakerOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getMakerOptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "MakerFilterInput" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "MakerFilterInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getMakerOptions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "MakerFilterInput" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMakerOptionsQuery,
  GetMakerOptionsQueryVariables
>
export const GetSubCategoryOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSubCategoryOptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "SubcategoryFilterInput" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "SubcategoryFilterInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getSubcategoryOptions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "SubcategoryFilterInput" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSubCategoryOptionsQuery,
  GetSubCategoryOptionsQueryVariables
>
export const GetItemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ItemFilterInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ItemFilterInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getFilteredItems" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filterInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ItemFilterInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "filteredItems" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maker_name_orig" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "intage_generic_category_lv3name",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "jicfs_lv4name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subcategory_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "brand_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subbrand_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "score_avg" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "score_cnt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "comment_cnt" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cnt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetItemsQuery, GetItemsQueryVariables>
export const GetAccountCategoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAccountCategory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "categoryDefinition1" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "categoryDefinition2" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "intageCategory" },
            name: { kind: "Name", value: "getCategoryOptions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "categoryDefinition" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "categoryDefinition1" },
                },
              },
            ],
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "jicfsCategory" },
            name: { kind: "Name", value: "getCategoryOptions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "categoryDefinition" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "categoryDefinition2" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAccountCategoryQuery,
  GetAccountCategoryQueryVariables
>
export const GetUnreadSummaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUnreadSummary" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUnreadSummary" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadInfoCnt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "uncheckedContactCnt" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUnreadSummaryQuery,
  GetUnreadSummaryQueryVariables
>
export const SaveAccountDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveAccountData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "Data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SaveAccountDataInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "saveAccountData" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountData" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "Data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "result" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveAccountDataMutation,
  SaveAccountDataMutationVariables
>
export const GetAcceptDateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAcceptDate" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAccountData" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "termsAcceptDate" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "getTerms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "content" } },
                { kind: "Field", name: { kind: "Name", value: "contentEn" } },
                { kind: "Field", name: { kind: "Name", value: "button" } },
                { kind: "Field", name: { kind: "Name", value: "buttonEn" } },
                { kind: "Field", name: { kind: "Name", value: "updateDate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAcceptDateQuery, GetAcceptDateQueryVariables>
export const GetInfoDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getInfoData" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getInfoData" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "infoDataItems" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "openDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "readed" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "delivered" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetInfoDataQuery, GetInfoDataQueryVariables>
export const GetUnreadSummaryHeaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getUnreadSummaryHeader" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUnreadSummary" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unreadInfoCnt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "uncheckedContactCnt" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUnreadSummaryHeaderQuery,
  GetUnreadSummaryHeaderQueryVariables
>
export const SaveDeliveryInfoDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveDeliveryInfoData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "Data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeliveryInfoDataInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "saveDeliveryInfoData" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "Data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "infoIds" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deliveryDate" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveDeliveryInfoDataMutation,
  SaveDeliveryInfoDataMutationVariables
>
export const GetContactsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getContacts" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getContacts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contacts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unread_cnt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetContactsQuery, GetContactsQueryVariables>
